import { render } from "./feed-provider-card.vue?vue&type=template&id=637c353f&scoped=true"
import script from "./feed-provider-card.vue?vue&type=script&lang=js"
export * from "./feed-provider-card.vue?vue&type=script&lang=js"

import "./feed-provider-card.vue?vue&type=style&index=0&id=637c353f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637c353f"]])

export default __exports__